// the index of array represents the value of sState (student state)
// 0:全部  1:未排班+已排版  2:未排班  3:在读  4:往期  5:续费
export default ["all", "all_not_archived", "not_enrolled", "enrolled", "archived", "pending_renewal"];



// WEBPACK FOOTER //
// ./src/controllers/constants/student-states.js